import React, { useState, useEffect } from 'react';
import { Calendar, Package, Users, Euro, AlertTriangle, CheckCircle, Clock, Leaf, ArrowRight, Sprout, X, Map, Cpu, Link, RefreshCw, TrendingUp, ClipboardList, ShoppingBag, FileText, BarChart3, Download } from 'lucide-react';
import Planification from './Planification';
import PlanMaraichage from './PlanMaraichage';
import GestionCarotte from './GestionCarotte';
import ConseillerWidget from './ConseillerWidget';
import FormulaireLiaisonCulture from './FormulaireLiaisonCulture';
import ModuleMSV from './ModuleMSV';
import GestionStatutsCommandesV2 from './GestionStatutsCommandesV2'; // 🆕 IMPORT V2
import AdminMessages from './AdminMessages';  
import { MessageSquare } from 'lucide-react'; 
const API_BASE = process.env.REACT_APP_API_URL || '/api';
const DashboardCockpit = () => {
  const [showPlanification, setShowPlanification] = useState(false);
  const [showPlanMairaichage, setShowPlanMairaichage] = useState(false);
  const [showGestionCarotte, setShowGestionCarotte] = useState(false);
  const [showLiaisonCulture, setShowLiaisonCulture] = useState(false);
  const [showMSV, setShowMSV] = useState(false);
  const [showGestionReservations, setShowGestionReservations] = useState(false); // 🆕 MODAL V2
  const [showBordereauModal, setShowBordereauModal] = useState(false); // 🆕 MODAL BORDEREAUX
  const [showMessages, setShowMessages] = useState(false);  // 📬 MODAL MESSAGES
 const [messagesCount, setMessagesCount] = useState(0);    // Compteur non lus
  const [stats, setStats] = useState({
    reservationsAujourdhui: 0,
    caEstime: 0,
    paniersPrets: 0,
    paniersARecolter: 0,
    alertesStock: 0,
    nouveauxClients: 0
  });
  
  // 🆕 Stats réservations détaillées pour l'encart V2
  const [statsReservations, setStatsReservations] = useState({
    en_attente: 0,
    confirmee: 0,
    en_preparation: 0,
    prete: 0,
    total: 0
  });
  
  // Stats cultures depuis la nouvelle API
  const [statsCultures, setStatsCultures] = useState({
    nb_parcelles_actives: 0,
    nb_parcelles_cultivees: 0,
    nb_parcelles_iot: 0,
    nb_cultures_actives: 0,
    surface_totale_cultivee: 0,
    rendement_total_prevu: 0,
    nb_alertes_eau: 0,
    nb_cultures_flags: 0
  });

  // Stats MSV
  const [statsMSV, setStatsMSV] = useState({
    progression: { total_jardins: 0, jardins_convertis: 0 },
    taches: { total: 0, faites: 0 },
    planches: { total: 0, msv: 0 }
  });
  
  const [actionsUrgentes, setActionsUrgentes] = useState([]);
  const [recolteJour, setRecolteJour] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadDashboard();
    // Rafraîchir toutes les 5 minutes
    const interval = setInterval(loadDashboard, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  const loadDashboard = async () => {
    try {
      // Stats globales
      const statsRes = await fetch(`${API_BASE}/dashboard/cockpit-fermier`);
      const statsData = await statsRes.json();
      
      if (statsData.success) {
        setStats(statsData.data.stats);
        setActionsUrgentes(statsData.data.actions);
        setRecolteJour(statsData.data.recolte);
      }
      
      // 🆕 Stats réservations par statut (pour l'encart V2)
      try {
        const resaRes = await fetch(`${API_BASE}/gestion-statuts/par-statut`);
        const resaData = await resaRes.json();
        if (resaData.success && resaData.data) {
          const data = resaData.data;
          setStatsReservations({
            en_attente: (data.en_attente || []).length,
            confirmee: (data.confirmee || []).length,
            en_preparation: (data.en_preparation || []).length,
            prete: (data.prete || []).length,
            total: (data.en_attente || []).length + (data.confirmee || []).length + 
                   (data.en_preparation || []).length + 
                   (data.prete || []).length
          });
        }
      } catch (err) {
        console.log('Stats réservations non disponibles');
      }
      
      // Stats cultures (nouvelle API)
      try {
        const culturesRes = await fetch(`${API_BASE}/cultures-gestion/cockpit-resume`);
        const culturesData = await culturesRes.json();
        if (culturesData.success && culturesData.data) {
          setStatsCultures(culturesData.data);
        }
      } catch (err) {
        console.log('Stats cultures non disponibles');
      }

      // Stats MSV
      try {
        const msvRes = await fetch(`${API_BASE}/msv/stats`);
        const msvData = await msvRes.json();
        if (msvData && msvData.progression) {
          setStatsMSV(msvData);
        }
      } catch (err) {
        console.log('Stats MSV non disponibles');
      }
      

      // Stats messages non lus
      try {
        const msgRes = await fetch(`${API_BASE}/messages/count`);
        const msgData = await msgRes.json();
        if (msgData.count !== undefined) {
          setMessagesCount(msgData.count);
        }
      } catch (err) {
        console.log('Stats messages non disponibles');
      }

      setLoading(false);
    } catch (error) {
      console.error('Erreur chargement cockpit:', error);
      setLoading(false);
    }
  };


  // Callback après création d'une culture
  const handleCultureCreated = (data) => {
    console.log('Culture créée:', data);
    loadDashboard(); // Rafraîchir les stats
  };

  // Calcul progression MSV
  const msvProgression = statsMSV.progression?.total_jardins > 0
    ? Math.round((statsMSV.progression.jardins_convertis / statsMSV.progression.total_jardins) * 100)
    : 0;

  const tachesProgression = statsMSV.taches?.total > 0
    ? Math.round((statsMSV.taches.faites / statsMSV.taches.total) * 100)
    : 0;

  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="text-lg text-gray-600">Chargement du cockpit...</div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      
      {/* 🌅 CONSEILLER AGRICOLE - TOUT EN HAUT ! */}
      <ConseillerWidget />

      {/* ═══════════════════════════════════════════════════════════════════════════ */}
      {/* 🆕 ENCART GESTION RÉSERVATIONS V2 - NOUVEAU ! */}
      {/* ═══════════════════════════════════════════════════════════════════════════ */}
      <div className="bg-gradient-to-r from-cyan-500 via-blue-500 to-indigo-600 rounded-xl shadow-lg p-6 text-white">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <div className="bg-white bg-opacity-20 rounded-full p-3">
              <ClipboardList className="w-8 h-8" />
            </div>
            <div>
              <h3 className="text-xl font-bold">📋 Gestion Réservations</h3>
              <p className="text-cyan-100 text-sm mt-1">
                Interface simplifiée • Actions groupées • Workflow optimisé
              </p>
            </div>
          </div>
          <button
            onClick={() => setShowGestionReservations(true)}
            className="flex items-center gap-2 bg-white text-blue-600 px-5 py-3 rounded-lg font-semibold hover:bg-blue-50 transition-all shadow-lg hover:shadow-xl"
          >
            <ShoppingBag className="w-5 h-5" />
            Gérer les réservations
            <ArrowRight className="w-4 h-4" />
          </button>
        </div>
        
        {/* Mini aperçu - Stats réservations par statut */}
        <div className="mt-4 grid grid-cols-5 gap-3">
          <div className="bg-yellow-400 bg-opacity-30 rounded-lg p-3 text-center border border-yellow-300 border-opacity-50">
            <div className="text-2xl font-bold">{statsReservations.en_attente}</div>
            <div className="text-xs text-yellow-100">⏳ En Attente</div>
          </div>
          <div className="bg-blue-400 bg-opacity-30 rounded-lg p-3 text-center border border-blue-300 border-opacity-50">
            <div className="text-2xl font-bold">{statsReservations.confirmee}</div>
            <div className="text-xs text-blue-100">✓ Confirmés</div>
          </div>
          <div className="bg-orange-400 bg-opacity-30 rounded-lg p-3 text-center border border-orange-300 border-opacity-50">
            <div className="text-2xl font-bold">{statsReservations.en_preparation}</div>
            <div className="text-xs text-orange-100">📦 Préparation</div>
          </div>
          <div className="bg-green-400 bg-opacity-30 rounded-lg p-3 text-center border border-green-300 border-opacity-50">
            <div className="text-2xl font-bold">{statsReservations.prete}</div>
            <div className="text-xs text-green-100">✅ Prêts</div>
          </div>
          <div className="bg-white bg-opacity-20 rounded-lg p-3 text-center">
            <div className="text-2xl font-bold">{statsReservations.total}</div>
            <div className="text-xs text-cyan-100">🛒 Total actif</div>
          </div>
        </div>
        
        {/* Indicateur workflow simplifié */}
        <div className="mt-4 flex items-center justify-center gap-2 bg-white bg-opacity-10 rounded-lg p-3">
          <span className="px-3 py-1 bg-yellow-500 rounded-full text-xs font-bold">Attente</span>
          <ArrowRight className="w-4 h-4 text-white opacity-60" />
          <span className="px-3 py-1 bg-blue-500 rounded-full text-xs font-bold">Confirmé</span>
          <ArrowRight className="w-4 h-4 text-white opacity-60" />
          <span className="px-3 py-1 bg-orange-500 rounded-full text-xs font-bold">Préparation</span>
          <ArrowRight className="w-4 h-4 text-white opacity-60" />
          <span className="px-3 py-1 bg-green-500 rounded-full text-xs font-bold">Prêt</span>
          <ArrowRight className="w-4 h-4 text-white opacity-60" />
          <span className="px-3 py-1 bg-gray-500 rounded-full text-xs font-bold">Retirée</span>
        </div>

        {/* 🆕 BOUTONS ÉTATS PDF */}
        <div className="mt-4 pt-4 border-t border-white border-opacity-20">
          <div className="flex items-center gap-2 mb-3">
            <FileText className="w-4 h-4" />
            <span className="text-sm font-medium">États PDF :</span>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-2 mb-2">
            <button
              onClick={() => window.open(`${API_BASE}/etats-pdf/recap-clients`, '_blank')}
              className="flex items-center justify-center gap-2 bg-white bg-opacity-20 hover:bg-opacity-30 px-3 py-2 rounded-lg text-sm font-medium transition-all"
              title="Récapitulatif par client avec montants"
            >
              <Users className="w-4 h-4" />
              Récap Clients
            </button>
            <button
              onClick={() => setShowBordereauModal(true)}
              className="flex items-center justify-center gap-2 bg-white bg-opacity-20 hover:bg-opacity-30 px-3 py-2 rounded-lg text-sm font-medium transition-all"
              title="Bordereau de livraison détaillé"
            >
              <FileText className="w-4 h-4" />
              Bordereaux
            </button>
            <button
              onClick={() => window.open(`${API_BASE}/etats-pdf/stock-delta`, '_blank')}
              className="flex items-center justify-center gap-2 bg-white bg-opacity-20 hover:bg-opacity-30 px-3 py-2 rounded-lg text-sm font-medium transition-all"
              title="Tables de comparaison"
            >
              <BarChart3 className="w-4 h-4" />
              Stock/Delta
            </button>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
            <button
              onClick={() => window.open(`${API_BASE}/etats-pdf/recap-semaine`, '_blank')}
              className="flex items-center justify-center gap-2 bg-white bg-opacity-20 hover:bg-opacity-30 px-3 py-2 rounded-lg text-sm font-medium transition-all"
              title="Récapitulatif semainier complet"
            >
              <Calendar className="w-4 h-4" />
              Récap Semaine
            </button>
            <button
              onClick={() => window.open(`${API_BASE}/etats-pdf/recap-mois?mois=${new Date().getMonth() + 1}&annee=${new Date().getFullYear()}`, '_blank')}
              className="flex items-center justify-center gap-2 bg-emerald-500 bg-opacity-80 hover:bg-opacity-100 px-3 py-2 rounded-lg text-sm font-medium transition-all border border-emerald-300"
              title="Récapitulatif du mois en cours"
            >
              <TrendingUp className="w-4 h-4" />
              Récap Mois
            </button>
            <button
              onClick={() => window.open(`${API_BASE}/etats-pdf/recap-annee?annee=${new Date().getFullYear()}`, '_blank')}
              className="flex items-center justify-center gap-2 bg-amber-500 bg-opacity-80 hover:bg-opacity-100 px-3 py-2 rounded-lg text-sm font-medium transition-all border border-amber-300"
              title="Bilan annuel complet"
            >
              <BarChart3 className="w-4 h-4" />
              Bilan Annuel
            </button>
          </div>
        </div>
      </div>


      {/* 🔗 ENCART LIAISON PARCELLE ↔ ESP32 ↔ CULTURE */}
      <div className="bg-gradient-to-r from-purple-500 via-indigo-500 to-blue-500 rounded-xl shadow-lg p-6 text-white">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <div className="bg-white bg-opacity-20 rounded-full p-3">
              <Link className="w-8 h-8" />
            </div>
            <div>
              <h3 className="text-xl font-bold">🔗 Liaison Parcelle ↔ ESP32 ↔ Culture</h3>
              <p className="text-purple-100 text-sm mt-1">
                Associer une parcelle, un module IoT et une culture • Coefficients Kc FAO-56
              </p>
            </div>
          </div>
          <button
            onClick={() => setShowLiaisonCulture(true)}
            className="flex items-center gap-2 bg-white text-purple-600 px-5 py-3 rounded-lg font-semibold hover:bg-purple-50 transition-all shadow-lg hover:shadow-xl"
          >
            <Cpu className="w-5 h-5" />
            Nouvelle liaison
            <ArrowRight className="w-4 h-4" />
          </button>
        </div>
        
        {/* Mini aperçu - Stats dynamiques */}
        <div className="mt-4 grid grid-cols-4 gap-3">
          <div className="bg-white bg-opacity-20 rounded-lg p-3 text-center">
            <div className="text-2xl font-bold">{statsCultures.nb_parcelles_actives || 0}</div>
            <div className="text-xs text-purple-100">Parcelles</div>
          </div>
          <div className="bg-white bg-opacity-20 rounded-lg p-3 text-center">
            <div className="text-2xl font-bold">{statsCultures.nb_cultures_actives || 0}</div>
            <div className="text-xs text-purple-100">Cultures actives</div>
          </div>
          <div className="bg-white bg-opacity-20 rounded-lg p-3 text-center">
            <div className="text-2xl font-bold">{statsCultures.nb_parcelles_iot || 0}</div>
            <div className="text-xs text-purple-100">Modules IoT</div>
          </div>
          <div className="bg-white bg-opacity-20 rounded-lg p-3 text-center">
            <div className="text-2xl font-bold text-yellow-300">{statsCultures.nb_alertes_eau || 0}</div>
            <div className="text-xs text-purple-100">Alertes eau</div>
          </div>
        </div>
      </div>


{/* 📬 ENCART MESSAGES DE CONTACT */}
<div className="bg-gradient-to-r from-amber-500 via-orange-500 to-red-500 rounded-xl shadow-lg p-6 text-white">
  <div className="flex items-center justify-between">
    <div className="flex items-center gap-4">
      <div className="bg-white bg-opacity-20 rounded-full p-3">
        <MessageSquare className="w-8 h-8" />
      </div>
      <div>
        <h3 className="text-xl font-bold">📬 Messages de Contact</h3>
        <p className="text-amber-100 text-sm mt-1">
          Consulter et répondre aux messages des clients
        </p>
      </div>
    </div>
    <div className="flex items-center gap-4">
      {messagesCount > 0 && (
        <div className="bg-white text-red-600 px-4 py-2 rounded-full font-bold animate-pulse">
          {messagesCount} non lu{messagesCount > 1 ? 's' : ''}
        </div>
      )}
      <button
        onClick={() => setShowMessages(true)}
        className="flex items-center gap-2 bg-white text-orange-600 px-5 py-3 rounded-lg font-semibold hover:bg-orange-50 transition-all shadow-lg hover:shadow-xl"
      >
        <MessageSquare className="w-5 h-5" />
        Voir les messages
        <ArrowRight className="w-4 h-4" />
      </button>
    </div>
  </div>
</div>


      {/* 🌱 ENCART PLANIFICATION CULTURES */}
      <div className="bg-gradient-to-r from-emerald-500 via-green-500 to-teal-500 rounded-xl shadow-lg p-6 text-white">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <div className="bg-white bg-opacity-20 rounded-full p-3">
              <Sprout className="w-8 h-8" />
            </div>
            <div>
              <h3 className="text-xl font-bold">🌱 Planification Cultures</h3>
              <p className="text-emerald-100 text-sm mt-1">
                Calendrier semis, plantations et récoltes • Prévisions de stock
              </p>
            </div>
          </div>
          <button
            onClick={() => setShowPlanification(true)}
            className="flex items-center gap-2 bg-white text-emerald-600 px-5 py-3 rounded-lg font-semibold hover:bg-emerald-50 transition-all shadow-lg hover:shadow-xl"
          >
            <Calendar className="w-5 h-5" />
            Voir le calendrier
            <ArrowRight className="w-4 h-4" />
          </button>
        </div>
        
        {/* Mini aperçu - Stats dynamiques */}
        <div className="mt-4 grid grid-cols-3 gap-3">
          <div className="bg-white bg-opacity-20 rounded-lg p-3 text-center">
            <div className="text-2xl font-bold">{statsCultures.nb_cultures_actives || 0}</div>
            <div className="text-xs text-emerald-100">Cultures actives</div>
          </div>
          <div className="bg-white bg-opacity-20 rounded-lg p-3 text-center">
            <div className="text-2xl font-bold">{statsCultures.surface_totale_cultivee || 0} m²</div>
            <div className="text-xs text-emerald-100">Surface cultivée</div>
          </div>
          <div className="bg-white bg-opacity-20 rounded-lg p-3 text-center">
            <div className="text-2xl font-bold">{((statsCultures.rendement_total_prevu || 0) / 1000).toFixed(1)}T</div>
            <div className="text-xs text-emerald-100">Rendement prévu</div>
          </div>
        </div>
      </div>

      {/* 📦 LISTE DE RÉCOLTE DU JOUR */}
      <div className="bg-white rounded-xl shadow-lg p-6">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-bold text-gray-900 flex items-center">
            <Package className="w-6 h-6 mr-2 text-green-600" />
            🌱 Liste de Récolte du Jour
          </h2>
          <button
            onClick={() => window.print()}
            className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700"
          >
            🖨️ Imprimer
          </button>
        </div>

        {recolteJour.length === 0 ? (
          <div className="text-center py-8 text-gray-500">
            <CheckCircle className="w-12 h-12 mx-auto mb-3 text-green-500" />
            <p className="text-lg">Aucune récolte prévue aujourd'hui !</p>
          </div>
        ) : (
          <div className="overflow-hidden rounded-lg border">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Produit</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Quantité à récolter</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Stock actuel</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Nb clients</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Statut</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {recolteJour.map((item, index) => (
                  <tr key={index} className="hover:bg-gray-50">
                    <td className="px-4 py-3 font-medium">{item.nom_produit}</td>
                    <td className="px-4 py-3">{item.quantite_a_recolter} {item.unite}</td>
                    <td className="px-4 py-3">{item.stock_actuel} {item.unite}</td>
                    <td className="px-4 py-3">{item.nb_clients}</td>
                    <td className="px-4 py-3">
                      <span className={`px-2 py-1 rounded-full text-xs ${
                        item.statut === 'urgent' ? 'bg-red-100 text-red-800' :
                        item.statut === 'ok' ? 'bg-green-100 text-green-800' :
                        'bg-yellow-100 text-yellow-800'
                      }`}>
                        {item.statut}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* 🗺️ ENCART PLAN MARAÎCHAGE */}
      <div className="bg-gradient-to-r from-amber-400 via-orange-500 to-red-500 rounded-xl shadow-lg p-6 text-white">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <div className="bg-white bg-opacity-20 rounded-full p-3">
              <Map className="w-8 h-8" />
            </div>
            <div>
              <h3 className="text-xl font-bold">🗺️ Plan du Maraîchage</h3>
              <p className="text-amber-100 text-sm mt-1">
                Vue satellite • Parcelles • Serres • Frigos • Point de vente
              </p>
            </div>
          </div>
          <button
            onClick={() => setShowPlanMairaichage(true)}
            className="flex items-center gap-2 bg-white text-orange-600 px-5 py-3 rounded-lg font-semibold hover:bg-orange-50 transition-all shadow-lg hover:shadow-xl"
          >
            <Map className="w-5 h-5" />
            Voir le plan
            <ArrowRight className="w-4 h-4" />
          </button>
        </div>
        
        {/* Mini aperçu */}
        <div className="mt-4 grid grid-cols-4 gap-3">
          <div className="bg-white bg-opacity-20 rounded-lg p-3 text-center">
            <div className="text-2xl font-bold">{statsCultures.nb_parcelles_actives || 6}</div>
            <div className="text-xs text-amber-100">Parcelles</div>
          </div>
          <div className="bg-white bg-opacity-20 rounded-lg p-3 text-center">
            <div className="text-2xl font-bold">2</div>
            <div className="text-xs text-amber-100">Serres</div>
          </div>
          <div className="bg-white bg-opacity-20 rounded-lg p-3 text-center">
            <div className="text-2xl font-bold">2</div>
            <div className="text-xs text-amber-100">Frigos</div>
          </div>
          <div className="bg-white bg-opacity-20 rounded-lg p-3 text-center">
            <div className="text-2xl font-bold">1</div>
            <div className="text-xs text-amber-100">Point vente</div>
          </div>
        </div>
      </div>

      {/* 🥕 ENCART GESTION CAROTTE - FAO-56 (DÉMO - À DÉPLACER PLUS TARD)
      <div className="bg-gradient-to-r from-orange-400 via-orange-500 to-amber-500 rounded-xl shadow-lg p-6 text-white">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <div className="bg-white bg-opacity-20 rounded-full p-3">
              <span className="text-3xl">🥕</span>
            </div>
            <div>
              <h3 className="text-xl font-bold">🥕 Gestion Carotte</h3>
              <p className="text-orange-100 text-sm mt-1">
                Simulateur FAO-56 • Coefficients Kc • Calcul ETc • Timeline culture
              </p>
            </div>
          </div>
          <button
            onClick={() => setShowGestionCarotte(true)}
            className="flex items-center gap-2 bg-white text-orange-600 px-5 py-3 rounded-lg font-semibold hover:bg-orange-50 transition-all shadow-lg hover:shadow-xl"
          >
            <Sprout className="w-5 h-5" />
            Simuler culture
            <ArrowRight className="w-4 h-4" />
          </button>
        </div>
        
        <div className="mt-4 grid grid-cols-4 gap-3">
          <div className="bg-white bg-opacity-20 rounded-lg p-3 text-center">
            <div className="text-lg font-bold">INIT</div>
            <div className="text-2xl font-bold">0.70</div>
            <div className="text-xs text-orange-100">Kc Germination</div>
          </div>
          <div className="bg-white bg-opacity-20 rounded-lg p-3 text-center">
            <div className="text-lg font-bold">DEV</div>
            <div className="text-2xl font-bold">0.85</div>
            <div className="text-xs text-orange-100">Kc Développement</div>
          </div>
          <div className="bg-white bg-opacity-20 rounded-lg p-3 text-center">
            <div className="text-lg font-bold">MID</div>
            <div className="text-2xl font-bold">1.05</div>
            <div className="text-xs text-orange-100">Kc Grossissement</div>
          </div>
          <div className="bg-white bg-opacity-20 rounded-lg p-3 text-center">
            <div className="text-lg font-bold">FIN</div>
            <div className="text-2xl font-bold">0.95</div>
            <div className="text-xs text-orange-100">Kc Maturation</div>
          </div>
        </div>
      </div>
      */}

      {/* ═══════════════════════════════════════════════════════════════════════════ */}
      {/* 🌱🪱 ENCART MSV - MARAÎCHAGE SUR SOL VIVANT */}
      {/* ═══════════════════════════════════════════════════════════════════════════ */}
      <div className="bg-gradient-to-r from-lime-500 via-green-600 to-emerald-700 rounded-xl shadow-lg p-6 text-white">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <div className="bg-white bg-opacity-20 rounded-full p-3">
              <span className="text-3xl">🪱</span>
            </div>
            <div>
              <h3 className="text-xl font-bold">🌱 Maraîchage Sur Sol Vivant</h3>
              <p className="text-lime-100 text-sm mt-1">
                Transition 2026-2030 • Rotation 6 familles • Checklist annuelle • Indicateurs
              </p>
            </div>
          </div>
          <button
            onClick={() => setShowMSV(true)}
            className="flex items-center gap-2 bg-white text-green-700 px-5 py-3 rounded-lg font-semibold hover:bg-green-50 transition-all shadow-lg hover:shadow-xl"
          >
            <Leaf className="w-5 h-5" />
            Voir le module MSV
            <ArrowRight className="w-4 h-4" />
          </button>
        </div>
        
        {/* Mini aperçu MSV - Stats dynamiques */}
        <div className="mt-4 grid grid-cols-4 gap-3">
          <div className="bg-white bg-opacity-20 rounded-lg p-3 text-center">
            <div className="text-2xl font-bold">{msvProgression}%</div>
            <div className="text-xs text-lime-100">Progression</div>
            {/* Mini barre de progression */}
            <div className="mt-1 w-full bg-white bg-opacity-30 rounded-full h-1.5">
              <div 
                className="bg-white rounded-full h-1.5 transition-all duration-500"
                style={{ width: `${msvProgression}%` }}
              />
            </div>
          </div>
          <div className="bg-white bg-opacity-20 rounded-lg p-3 text-center">
            <div className="text-2xl font-bold">
              {statsMSV.progression?.jardins_convertis || 0}/{statsMSV.progression?.total_jardins || 0}
            </div>
            <div className="text-xs text-lime-100">Jardins convertis</div>
          </div>
          <div className="bg-white bg-opacity-20 rounded-lg p-3 text-center">
            <div className="text-2xl font-bold">
              {statsMSV.planches?.msv || 0}/{statsMSV.planches?.total || 0}
            </div>
            <div className="text-xs text-lime-100">Planches MSV</div>
          </div>
          <div className="bg-white bg-opacity-20 rounded-lg p-3 text-center">
            <div className="text-2xl font-bold">{tachesProgression}%</div>
            <div className="text-xs text-lime-100">Tâches {statsMSV.annee_courante || 2026}</div>
            {/* Mini barre de progression */}
            <div className="mt-1 w-full bg-white bg-opacity-30 rounded-full h-1.5">
              <div 
                className="bg-yellow-300 rounded-full h-1.5 transition-all duration-500"
                style={{ width: `${tachesProgression}%` }}
              />
            </div>
          </div>
        </div>

        {/* Phases de transition - mini timeline */}
        <div className="mt-4 flex items-center justify-between bg-white bg-opacity-10 rounded-lg p-3">
          <div className="flex items-center gap-2">
            <TrendingUp className="w-5 h-5" />
            <span className="text-sm font-medium">Phases:</span>
          </div>
          <div className="flex gap-2">
            {[2026, 2027, 2028, 2029, 2030].map((annee, idx) => {
              const colors = ['#22c55e', '#3b82f6', '#f59e0b', '#8b5cf6', '#ef4444'];
              const isActive = annee === (statsMSV.annee_courante || 2026);
              return (
                <div 
                  key={annee}
                  className={`px-3 py-1 rounded-full text-xs font-bold ${isActive ? 'ring-2 ring-white' : 'opacity-70'}`}
                  style={{ backgroundColor: colors[idx] }}
                >
                  {annee}
                </div>
              );
            })}
          </div>
          <div className="text-sm">
            <span className="text-lime-200">Objectif:</span> <span className="font-bold">100% en 2030</span>
          </div>
        </div>
      </div>

      {/* ⏰ DERNIÈRE MAJ */}
      <div className="text-center text-sm text-gray-500 flex items-center justify-center">
        <Clock className="w-4 h-4 mr-1" />
        Dernière mise à jour : {new Date().toLocaleTimeString('fr-FR')}
      </div>

      {/* ═══════════════════════════════════════════════════════════════════════════ */}
      {/* 🆕 MODAL GESTION RÉSERVATIONS V2 */}
      {/* ═══════════════════════════════════════════════════════════════════════════ */}
      {showGestionReservations && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
          <div className="bg-gray-100 rounded-xl max-w-7xl w-full max-h-[95vh] overflow-auto shadow-2xl">
            <div className="sticky top-0 bg-gradient-to-r from-cyan-500 via-blue-500 to-indigo-600 p-4 border-b flex justify-between items-center z-10 shadow-sm">
              <h2 className="text-xl font-bold flex items-center gap-2 text-white">
                <ClipboardList className="w-6 h-6" />
                📋 Gestion des Réservations - Interface V2
              </h2>
              <button 
                onClick={() => {
                  setShowGestionReservations(false);
                  loadDashboard(); // Rafraîchir les stats au retour
                }} 
                className="p-2 hover:bg-white hover:bg-opacity-20 rounded-lg transition-colors"
              >
                <X className="w-6 h-6 text-white" />
              </button>
            </div>
            <div className="p-4">
              <GestionStatutsCommandesV2 />
            </div>
          </div>
        </div>
      )}

      {/* 🔗 MODAL LIAISON PARCELLE ↔ ESP32 ↔ CULTURE */}
      {showLiaisonCulture && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
          <FormulaireLiaisonCulture 
            onClose={() => setShowLiaisonCulture(false)}
            onSuccess={handleCultureCreated}
          />
        </div>
      )}

      {/* 🌱 MODAL PLANIFICATION */}
      {showPlanification && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
          <div className="bg-gray-100 rounded-xl max-w-7xl w-full max-h-[95vh] overflow-auto shadow-2xl">
            <div className="sticky top-0 bg-white p-4 border-b flex justify-between items-center z-10 shadow-sm">
              <h2 className="text-xl font-bold flex items-center gap-2">
                <Sprout className="w-6 h-6 text-green-600" />
                🌱 Planification Cultures
              </h2>
              <button onClick={() => setShowPlanification(false)} className="p-2 hover:bg-gray-100 rounded-lg transition-colors">
                <X className="w-6 h-6 text-gray-500" />
              </button>
            </div>
            <Planification />
          </div>
        </div>
      )}

      {/* 🗺️ MODAL PLAN MARAÎCHAGE */}
      {showPlanMairaichage && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
          <div className="bg-gray-100 rounded-xl max-w-7xl w-full max-h-[95vh] overflow-auto shadow-2xl">
            <div className="sticky top-0 bg-white p-4 border-b flex justify-between items-center z-10 shadow-sm">
              <h2 className="text-xl font-bold flex items-center gap-2">
                <Map className="w-6 h-6 text-orange-600" />
                🗺️ Plan du Maraîchage
              </h2>
              <button onClick={() => setShowPlanMairaichage(false)} className="p-2 hover:bg-gray-100 rounded-lg transition-colors">
                <X className="w-6 h-6 text-gray-500" />
              </button>
            </div>
            <PlanMaraichage />
          </div>
        </div>
      )}

      {/* 🥕 MODAL GESTION CAROTTE */}
      {showGestionCarotte && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
          <div className="bg-gray-100 rounded-xl max-w-7xl w-full max-h-[95vh] overflow-auto shadow-2xl">
            <div className="sticky top-0 bg-white p-4 border-b flex justify-between items-center z-10 shadow-sm">
              <h2 className="text-xl font-bold flex items-center gap-2">
                <span className="text-2xl">🥕</span>
                Gestion Carotte - Simulateur FAO-56
              </h2>
              <button onClick={() => setShowGestionCarotte(false)} className="p-2 hover:bg-gray-100 rounded-lg transition-colors">
                <X className="w-6 h-6 text-gray-500" />
              </button>
            </div>
            <GestionCarotte />
          </div>
        </div>
      )}

      {/* 🌱🪱 MODAL MSV */}
      {showMSV && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
          <div className="bg-gray-100 rounded-xl max-w-7xl w-full max-h-[95vh] overflow-auto shadow-2xl">
            <div className="sticky top-0 bg-gradient-to-r from-lime-500 to-green-600 p-4 border-b flex justify-between items-center z-10 shadow-sm">
              <h2 className="text-xl font-bold flex items-center gap-2 text-white">
                <span className="text-2xl">🪱</span>
                Maraîchage Sur Sol Vivant - Transition 2026-2030
              </h2>
              <button onClick={() => setShowMSV(false)} className="p-2 hover:bg-white hover:bg-opacity-20 rounded-lg transition-colors">
                <X className="w-6 h-6 text-white" />
              </button>
            </div>
            {/* Contenu - Module MSV complet */}
            <div className="p-4">
              <ModuleMSV />
            </div>
          </div>
        </div>
      )}

      {/* 📄 MODAL SÉLECTION BORDEREAUX */}
      {showBordereauModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-xl max-w-2xl w-full shadow-2xl">
            <div className="bg-gradient-to-r from-blue-500 to-indigo-600 p-4 rounded-t-xl flex justify-between items-center">
              <h2 className="text-xl font-bold text-white flex items-center gap-2">
                <FileText className="w-6 h-6" />
                📄 Génération Bordereaux PDF
              </h2>
              <button 
                onClick={() => setShowBordereauModal(false)} 
                className="p-2 hover:bg-white hover:bg-opacity-20 rounded-lg transition-colors"
              >
                <X className="w-6 h-6 text-white" />
              </button>
            </div>
            
            <div className="p-6 space-y-4">
              <p className="text-gray-600">
                Choisissez le type de bordereau à générer :
              </p>
              
              {/* Option 1 : Tous les bordereaux "Prêtes" */}
              <button
                onClick={() => {
                  window.open(`${API_BASE}/etats-pdf/bordereaux-batch?statut=prete`, '_blank');
                  setShowBordereauModal(false);
                }}
                className="w-full flex items-center gap-4 p-4 bg-green-50 hover:bg-green-100 border-2 border-green-200 rounded-xl transition-all"
              >
                <div className="bg-green-500 text-white p-3 rounded-lg">
                  <Download className="w-6 h-6" />
                </div>
                <div className="text-left">
                  <div className="font-bold text-green-800">📦 Tous les bordereaux "PRETS"</div>
                  <div className="text-sm text-green-600">
                    Génère un PDF avec tous les bordereaux des commandes prêtes au retrait
                  </div>
                </div>
                <span className="ml-auto bg-green-500 text-white px-3 py-1 rounded-full text-sm font-bold">
                  {statsReservations.prete}
                </span>
              </button>
              
              {/* Option 2 : Bordereaux par statut */}
              <div className="grid grid-cols-2 gap-3">
                <button
                  onClick={() => {
                    window.open(`${API_BASE}/etats-pdf/bordereaux-batch?statut=en_preparation`, '_blank');
                    setShowBordereauModal(false);
                  }}
                  className="flex items-center gap-2 p-3 bg-orange-50 hover:bg-orange-100 border border-orange-200 rounded-lg transition-all"
                >
                  <Package className="w-5 h-5 text-orange-600" />
                  <span className="text-orange-800 font-medium">En Préparation</span>
                  <span className="ml-auto bg-orange-500 text-white px-2 py-0.5 rounded text-xs">
                    {statsReservations.en_preparation}
                  </span>
                </button>
                
                <button
                  onClick={() => {
                    window.open(`${API_BASE}/etats-pdf/bordereaux-batch?statut=confirmee`, '_blank');
                    setShowBordereauModal(false);
                  }}
                  className="flex items-center gap-2 p-3 bg-blue-50 hover:bg-blue-100 border border-blue-200 rounded-lg transition-all"
                >
                  <CheckCircle className="w-5 h-5 text-blue-600" />
                  <span className="text-blue-800 font-medium">Confirmés</span>
                  <span className="ml-auto bg-blue-500 text-white px-2 py-0.5 rounded text-xs">
                    {statsReservations.confirmee}
                  </span>
                </button>
              </div>
              
              {/* Info */}
              <div className="bg-gray-50 p-3 rounded-lg text-sm text-gray-500 flex items-start gap-2">
                <AlertTriangle className="w-4 h-4 mt-0.5 text-amber-500" />
                <span>
                  Pour un bordereau individuel, ouvrez la gestion des réservations et sélectionnez une commande spécifique.
                </span>
              </div>
            </div>
            
            <div className="bg-gray-50 px-6 py-4 rounded-b-xl flex justify-end">
              <button
                onClick={() => setShowBordereauModal(false)}
                className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors"
              >
                Fermer
              </button>
            </div>
          </div>
        </div>
      )}
 {/* 📬 MODAL MESSAGES */}
{showMessages && (
  <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
    <div className="bg-white rounded-xl max-w-5xl w-full max-h-[95vh] overflow-auto shadow-2xl">
      <div className="sticky top-0 bg-gradient-to-r from-amber-500 to-orange-600 p-4 flex justify-between items-center z-10 shadow-sm">
        <h2 className="text-xl font-bold flex items-center gap-2 text-white">
          <MessageSquare className="w-6 h-6" />
          📬 Messages de Contact
        </h2>
        <button 
          onClick={() => setShowMessages(false)} 
          className="p-2 hover:bg-white hover:bg-opacity-20 rounded-lg transition-colors"
        >
          <X className="w-6 h-6 text-white" />
        </button>
      </div>
      <div className="p-4">
        <AdminMessages 
          onUpdate={() => {
            // Rafraîchir le compteur après action
            fetch(`${API_BASE}/messages/count`)
              .then(res => res.json())
              .then(data => setMessagesCount(data.count || 0))
              .catch(console.error);
          }} 
        />
      </div>
    </div>
  </div>
)}


    </div>
  );
};

export default DashboardCockpit;